// Shown instead of the admin page once its access token can no longer be used: the link was
// opened after its token expired, or the API refused to refresh the token. The token cannot
// be renewed at that point (the API only refreshes a still-valid one), so the only way back
// in is a fresh link.
export default function LinkExpired() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-2 px-6 text-center">
      <p className="font-semibold text-gray-800">Your link has expired</p>
      <p className="max-w-sm text-sm text-gray-500">
        This admin link is no longer valid. Ask the session admin for a new one to continue.
      </p>
    </div>
  );
}
